import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './forbidden-403.module.scss'

export function Forbidden403Page() {    
    const { t } = useTranslation()
    return (
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.gradient}></div>
                    <div className={styles.name}>{t('forbidden-403.forbidden')}</div>
                </div>
            </div>
    )
}
